export default __webpack_public_path__ + "static/media/blueUser.03fcc459.svg";